var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ui-input-base-select',_vm._b({attrs:{"is-invalid":_vm.isInvalid},on:{"change":_vm.changeHandler,"focus":_vm.focusHandler,"blur":_vm.blurHandler}},'ui-input-base-select',{ ..._vm.model },false))
}
var staticRenderFns = []

export { render, staticRenderFns }